import axios from 'axios';
import { ROOT_API_URL } from '../../../api-config';
import { loader, toastr } from '../CommonActions';
import { auth, userService} from '../../../services';

export const GET_ALL_ORDERS = 'GET_ALL_ORDERS';
export const GET_ORDER_DETAILS = 'GET_ORDER_DETAILS';
export const UPDATE_ORDER = 'UPDATE_ORDER';

const successColor = 'success';
const errorColor = 'danger';
const warningColor = 'warning';

export function fetchAllOrders() {
	return function(dispatch) {
        dispatch(loader(true));
		var url = `${ROOT_API_URL}/ManageOrder/GetOrders`;
		const options = { method: 'GET', headers: auth.authHeader() };
		axios
			.get(url, options)
			.then((response) => {
				dispatch({
					type: GET_ALL_ORDERS,
					payload: response.data
				});
				dispatch(loader(false));
			})
			.catch((error) => {
				var err = "Network Connection Error"; 
				dispatch(loader(false));		
				dispatch(toastr(true,err, errorColor));
			});
	};
}

export function fetchOrderDetails(orderId) {
	return function(dispatch) {
		dispatch(loader(true));
		var url = `${ROOT_API_URL}/ManageOrder/GetOrderDetails?orderId=${orderId}`;
		const options = { method: 'GET', headers: auth.authHeader() };
		axios
			.get(url, options)
			.then((response) => {
				dispatch({
					type: GET_ORDER_DETAILS,
					payload: response.data
				});
				dispatch(loader(false));
			})
			.catch((error) => {
				var err = "Network Connection Error"; 
				dispatch(loader(false));		
				dispatch(toastr(true,err, errorColor));
			});
	};
}

export function updateOrder(order) {
	return function(dispatch) {
		dispatch(loader(true));
		var url = `${ROOT_API_URL}/ManageOrder/UpdateOrder`;
		const options = { method: 'POST', headers: auth.authHeader() };
		axios.post(url, order, options).then(function(response) {
				console.log("update response", response)
				if (response && response.data && response.data.issuccess) 
				{
					dispatch({
						type: UPDATE_ORDER,
						payload: response.data.orders
					});	
					var success = response && response.data ? response.data.message : "Order Updated Successfully"; 
					dispatch(toastr(true,success, successColor));
				}
				else {
					var err = response && response.data ? response.data.message : "Error Occured"; 
					dispatch(toastr(true,err, warningColor));
				}
				dispatch(loader(false));
			})
			.catch((response) => {
				var err = response && response.data ? response.data.message : 'Network Connection Error';
				dispatch(loader(false));
				dispatch(toastr(true, err, errorColor));
			});
	};
}